<template lang="pug">
.v-services-info.services-info(v-if="data" :id="data?.id")
	.services-info__head
		.services-info__title(v-if="data.title") {{data.title}}
		.services-info__tabs
			v-field(:field="tabField" :model-value="active.id" @update:model-value="handleInput")
	.services-info__body(v-if="active")
		.services-info__banner(v-if="active.image")
			img.services-info__banner-img(:src="active.image.src" :alt="active.image.alt")
		.services-info__content
			.services-info__list(v-if="active.items")
				.services-info__list-item(v-for="item in active.items")
					v-svg-icon.services-info__list-item-icon(icon="tick-marker")
					span.services-info__list-item-text {{item.text}}
					v-sticker.services-info__list-item-sticker(v-if="item.sticker" :data="{...item.sticker, size: 'm'}")
</template>

<script>

import sourceMixin from "components/mixins/v-mixin-source.vue";

export default {
	mixins: [
		sourceMixin
	],

	computed: {
		tabField() {
			return {
				type: 'tabs',
				options: this.data.items?.map(item => ({text: item.title, value: item.id}))
			}
		}
	},

	data() {
		return {
			data: null,
			active: null
		}
	},

	methods: {
		dataSet(data) {
			this.data = data;
			this.active = data.items[0];
		},

		handleInput(value) {
			this.active = this.data.items.find(item => item.id === value);
		}
	}
}

</script>